import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
export const useDMListStore = create()(persist((set, get)=>({
        dmlist: {},
        setDMLIst: (updateFn)=>set((state)=>({
                    dmlist: typeof updateFn === "function" ? updateFn(state.dmlist) : updateFn
                })),
        addRoom: (room)=>set((state)=>({
                    dmlist: {
                        ...state.dmlist,
                        [room.roomId]: room
                    }
                })),
        removeRoom: (roomId)=>set((state)=>{
                const { [roomId]: _, ...rest } = state.dmlist;
                return {
                    dmlist: rest
                };
            }),
        updateRoom: (roomId, updates)=>set((state)=>({
                    dmlist: {
                        ...state.dmlist,
                        [roomId]: state.dmlist[roomId] ? {
                            ...state.dmlist[roomId],
                            ...updates
                        } : state.dmlist[roomId]
                    }
                })),
        updateLastMessage: (roomId, message, timestamp)=>set((state)=>({
                    dmlist: {
                        ...state.dmlist,
                        [roomId]: state.dmlist[roomId] ? {
                            ...state.dmlist[roomId],
                            lastMessage: message,
                            lastMessageTime: timestamp
                        } : state.dmlist[roomId]
                    }
                })),
        updateUnreadCount: (roomId, count)=>set((state)=>({
                    dmlist: {
                        ...state.dmlist,
                        [roomId]: state.dmlist[roomId] ? {
                            ...state.dmlist[roomId],
                            unreadMessageCount: count
                        } : state.dmlist[roomId]
                    }
                })),
        incrementUnreadCount: (roomId)=>set((state)=>({
                    dmlist: {
                        ...state.dmlist,
                        [roomId]: state.dmlist[roomId] ? {
                            ...state.dmlist[roomId],
                            unreadMessageCount: (state.dmlist[roomId].unreadMessageCount || 0) + 1
                        } : state.dmlist[roomId]
                    }
                })),
        resetUnreadCount: (roomId)=>set((state)=>({
                    dmlist: {
                        ...state.dmlist,
                        [roomId]: state.dmlist[roomId] ? {
                            ...state.dmlist[roomId],
                            unreadMessageCount: 0
                        } : state.dmlist[roomId]
                    }
                })),
        searchRooms: (query)=>{
            const dmlist = get().dmlist;
            if (!query) return Object.values(dmlist);
            const lowerQuery = query.toLowerCase();
            return Object.values(dmlist).filter((room)=>room.roomName.toLowerCase().includes(lowerQuery) || room.participants?.some((p)=>p.displayName.toLowerCase().includes(lowerQuery)));
        },
        filterUnreadRooms: ()=>{
            const dmlist = get().dmlist;
            return Object.values(dmlist).filter((room)=>room.unreadMessageCount > 0);
        },
        filterGroupRooms: ()=>{
            const dmlist = get().dmlist;
            return Object.values(dmlist).filter((room)=>room.isGroupThread);
        },
        filterDirectRooms: ()=>{
            const dmlist = get().dmlist;
            return Object.values(dmlist).filter((room)=>!room.isGroupThread);
        },
        getTotalUnreadCount: ()=>{
            const dmlist = get().dmlist;
            return Object.values(dmlist).reduce((total, room)=>total + (room.unreadMessageCount || 0), 0);
        },
        getUnreadRoomCount: ()=>{
            const dmlist = get().dmlist;
            return Object.values(dmlist).filter((room)=>room.unreadMessageCount > 0).length;
        },
        getTotalRoomCount: ()=>{
            const dmlist = get().dmlist;
            return Object.keys(dmlist).length;
        },
        getSortedRooms: ()=>{
            const dmlist = get().dmlist;
            return Object.values(dmlist).sort((a, b)=>{
                const timeA = new Date(a.lastMessageTime).getTime();
                const timeB = new Date(b.lastMessageTime).getTime();
                return timeB - timeA;
            });
        },
        getSortedRoomsByPriority: ()=>{
            const dmlist = get().dmlist;
            return Object.values(dmlist).sort((a, b)=>{
                // 읽지 않은 메시지가 있는 채팅방을 우선
                if (a.unreadMessageCount > 0 && b.unreadMessageCount === 0) return -1;
                if (a.unreadMessageCount === 0 && b.unreadMessageCount > 0) return 1;
                // 그 다음은 시간 순
                const timeA = new Date(a.lastMessageTime).getTime();
                const timeB = new Date(b.lastMessageTime).getTime();
                return timeB - timeA;
            });
        }
    }), {
    name: "dm-list-storage",
    storage: createJSONStorage(()=>localStorage)
}));
